import { storage, StorageKey } from "util/Storage";

export default function userTimezone() {
  return storage.get(StorageKey.USER_TIMEZONE) || "America/Los_Angeles";
}
